<div class="print-loading-indicator__container">
    <ds-loading-spinner />
</div>
<div class="print-loading-indicator__text">{{ sitecore.myBets_Print.LoadingIndicatorText }}</div>
